import cn from '@/lib/clsxm';

import XImage from '@/components/@base/x-image';
import Section from '@/components/app/product/components/@shared/section';
import Tag from '@/components/app/product/components/tags/tag';
import Props from '@/components/app/product/components/tags/type';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function Tags({ tags, className, ...props }: Props) {
  return (
    <Section
      expandable
      className={cn(
        'flex flex-wrap items-center gap-2 bg-[#EFF1F3B2] md:px-[27px]! md:py-[22px]!',
        className,
      )} {...props}
      forcedMaxHeight={130}
    >
      <IconTextCombo
        title={productLocalization.tags}
        Icon={<XImage src={imagesList.icons.tagIcon} alt={productLocalization.tags} />}
        wrapperClassName='text-[#424244] p-0 gap-2 w-auto'
        textClassName='text-[#424244] font-bold'
      />
      {tags?.map((tagItem) => (
        <Tag className='min-w-fit first:mr-4 last:ml-4' {...tagItem} key={tagItem.id} />
      ))}
    </Section>
  );
}
